import { FC, PropsWithChildren } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

interface Props {
    anchorSelect: string;
}

const Tooltip: FC<PropsWithChildren & Props> = ({ children, anchorSelect }) => {
    return (
        <ReactTooltip
            anchorSelect={anchorSelect}
            className="tooltip"
            classNameArrow="tooltipArrow"
            style={{ zIndex: 1000 }}
            place="right"
        >
            {children}
        </ReactTooltip>
    );
};

export default Tooltip;
